import React from "react";
import { Button, icons } from "@a365/dsys";
import { useTranslation } from "react-i18next";

const {
  HandHeart,
  Laptop,
  PawPrint,
  SuitcaseRolling,
} = icons;

const Feature5 = ({ setOpenMod }) => {
  const { t } = useTranslation();

  return (
    <div id="section-feature5" className="bg-bg-secondary pt-12 xl:pt-16">
      <div
        className="
      bg-[url('https://assistcdn.s3.us-west-1.amazonaws.com/assets/img/home/SectionAdicionalesMobile.png')]
      max-w-[390px]:bg-[url('https://assistcdn.s3.us-west-1.amazonaws.com/assets/img/home/SectionAdicionalesMobile.png')]
      min-[391px]:bg-[url('https://assistcdn.s3.us-west-1.amazonaws.com/assets/img/home/SectionAdicionalesTablet.png')]
      min-[935px]:bg-[url('https://assistcdn.s3.us-west-1.amazonaws.com/assets/img/home/SectionAdicionalesDesktop.png')]
      bg-no-repeat
      md:bg-contain
      bg-bottom
      w-full flex flex-col items-start justify-start relative"
      >
        <div className="max-w-[548px] xl:max-w-[996px] mx-auto px-4 xl:px-0 xl:pb-16 pb-[48px]">
          <h2 className="font-semibold text-3xl xl:text-5xl text-text-decorative-darker leading-[48px]">
            {t("feature5.title")}
          </h2>
          <p className="text-xl xl:text-2xl text-text-lighter mt-3">
            {t("feature5.dropline")}
          </p>
          <div className="flex flex-col items-center xl:grid xl:grid-cols-2 xl:gap-6 mt-10 place-items-center gap-y-2">
            <div className="w-full xl:max-w-[486px] bg-white rounded-xl border border-border-secondary p-6 ml-auto flex xl:flex-col items-start xl:justify-center space-x-4 xl:space-x-0">
              <Laptop size={40} color="#31319B" />
              <div>
                <span className="text-xl text-text-default font-semibold block xl:mt-4">
                  {t("feature5.card1.title")}
                </span>
                <p className="text-text-lighter text-base">
                  {t("feature5.card1.content")}
                </p>
              </div>
            </div>
            <div className="w-full xl:max-w-[486px] bg-white rounded-xl border border-border-secondary p-6 ml-auto flex xl:flex-col items-start xl:justify-center space-x-4 xl:space-x-0">
              <HandHeart size={40} color="#31319B" />
              <div>
                <span className="text-xl text-text-default font-semibold block xl:mt-4">
                  {t("feature5.card2.title")}
                </span>
                <p className="text-text-lighter text-base">
                  {t("feature5.card2.content")}
                </p>
              </div>
            </div>

            <div className="w-full xl:max-w-[486px] bg-white rounded-xl border border-border-secondary p-6 ml-auto flex xl:flex-col items-start xl:justify-center space-x-4 xl:space-x-0">
              <SuitcaseRolling size={40} color="#31319B" />
              <div>
                <span className="text-xl text-text-default font-semibold block xl:mt-4">
                  {t("feature5.card3.title")}
                </span>
                <p className="text-text-lighter text-base">
                  {t("feature5.card3.content")}
                </p>
              </div>
            </div>

            <div className="w-full xl:max-w-[486px] bg-white rounded-xl border border-border-secondary p-6 ml-auto flex xl:flex-col items-start xl:justify-center space-x-4 xl:space-x-0">
              <PawPrint size={40} color="#31319B" />
              <div>
                <span className="text-xl text-text-default font-semibold block xl:mt-4">
                  {t("feature5.card4.title")}
                </span>
                <p className="text-text-lighter text-base">
                  {t("feature5.card4.content")}
                </p>
              </div>
            </div>
          </div>
          <div className="flex items-end justify-center xl:justify-end">
            <Button
              onClick={() => setOpenMod(true)}
              color="primary"
              variant="alt"
              fullWidth={true}
              size="large"
              icon="arrow"
              classes={"mt-6 w-full lg:w-fit"}
            >
              {t("feature5.btnLabel")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Feature5;
